import { useRef } from "react";
import { char, number } from "../../../../utils";
import { selector } from "../../../../api";
import moment from "moment";
import { Loader, Pagination } from "rsuite";

export const AccountIncome = (props) => {
  const {
    data,
    loading,
    limit,
    page,
    handleChangePage,
    handleChange,
    dataRef,
    tableRef,
  } = props;

  const user = selector.User();

  return (
    <>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "50vh", // Full viewport height
            overflow: "hidden",
          }}
        >
          <Loader
            backdrop
            size="md"
            speed="slow"
            content="Please wait..."
            vertical
          />
        </div>
      ) : (
        <>
          <div className="row">
            <div className="col-md-6 col-sm-12">
              <p className="h4">
                Total Collection :{" "}
                <span className="ms-3 h3">
                  {number.fNumberDoublePoint(data?.total_income_all)}
                </span>
              </p>
            </div>
            <div className="col-md-6 col-sm-12">
              <p className="h4">
                Total Collection for {limit} rows :{" "}
                <span className="ms-3 h3">
                  {number.fNumberDoublePoint(data?.total_income)}
                </span>
              </p>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-12" ref={dataRef}>
              <div className="printHead">
                <p className="text-center">
                  <img
                    width={100}
                    className="mt-0 mb-2"
                    src="assets/images/suza.jpeg"
                    alt=""
                  />
                </p>
                <p className="text-center fw-bold head1">
                  {char.toTitleCase("state university of Zanzibar")}
                </p>
                <p className="text-center mt-3 mb-3 head2">
                  {char.toUpperCase("item collection report")}
                </p>
                <p className="text-end">
                  Printed By :{" "}
                  <span className="fw-bold">
                    {char.toUpperCase(user.username)}
                  </span>
                </p>
                <p className="text-end mb-2">
                  Printed at :{" "}
                  <span className="fw-bold">
                    {moment().format("ddd DD MMM YYYY")}
                  </span>
                </p>
              </div>
              <div className="table-responsive" ref={tableRef}>
                <table className="table table-bordered table-sm">
                  <thead className="table-head">
                    <tr>
                      <th style={{ width: 50 }}>#</th>
                      <th>Date</th>
                      <th>Payer Ref No</th>
                      <th>Payer Name</th>
                      <th className="text-end">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.transactions?.map((dt, i) => (
                      <tr>
                        <td>{i + 1}</td>
                        <td>
                          {dt.timestamp
                            ? moment(dt.timestamp).format("ddd, DD MMM YYYY")
                            : "N/A"}
                        </td>
                        <td>
                          {dt.credit_account_code
                            ? char.toUpperCase(dt.credit_account_code)
                            : "N/A"}
                        </td>
                        <td>
                          {dt.credit_account_name
                            ? char.toUpperCase(dt.credit_account_name)
                            : "N/A"}
                        </td>
                        <td className="text-end">
                          {number.fNumberDoublePoint(dt.equivalent_amount)}
                        </td>
                      </tr>
                    ))}
                    {!data?.transactions?.length && (
                      <tr>
                        <td colSpan={8} className="text-center">
                          {char.toLowerCase("no data to print")}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-2 mt-3">
              <span>Total rows : &nbsp; {data?.total_transactions}</span>
            </div>
            <div className="col-10">
              <div className="row g-2 mt-2 justify-content-start justify-content-md-end align-items-center">
                <div className="col-auto paginate">
                  <Pagination
                    prev
                    last
                    next
                    first
                    ellipsis
                    boundaryLinks={true}
                    maxButtons={5}
                    size="sm"
                    limitOptions={[
                      5,
                      10,
                      20,
                      50,
                      100,
                      data?.total_transactions,
                    ]}
                    layout={["limit", "|", "pager", "|", "skip"]}
                    total={data?.total_transactions}
                    limit={limit}
                    activePage={page}
                    onChangePage={handleChangePage}
                    onChangeLimit={handleChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
